import React from 'react'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import * as S from './styled'
import { withI18n } from '../../hocs'
import { RegularButton, RegularButtonOutline } from '../../atoms'
import ActionDialog from '../action-dialog'

const ModalFilter = ({ filters, filtersValues, open, handleClose, i18n, handleSearchClick, filterName, children }) => {
  function handeOnSearch(e) {
    e.preventDefault()
    handleSearchClick()
    handleClose()
  }

  // El botón vive fuera del <form> (en el pie del diálogo); se asocia por id para que Intro
  // en cualquier campo siga lanzando la búsqueda
  return (
    <ActionDialog
      open={open}
      title={filterName}
      onClose={handleClose}
      maxWidth="md"
      disableBackdropClose
      actions={<>
        <RegularButtonOutline type="button" title={i18n.dialog.decline} onClick={handleClose} />
        <RegularButton type="submit" form="modal-filter-form" title={i18n.modalFilter.search} />
      </>}
    >
      <S.Body>
        <form id="modal-filter-form" onSubmit={handeOnSearch}>
          {children && React.cloneElement(children, { filtersValues, filters })}
        </form>
      </S.Body>
    </ActionDialog>
  )
}

ModalFilter.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  handleSearchClick: PropTypes.func,
  filters: PropTypes.array,
  filtersCitation: PropTypes.array,
  filtersValues: PropTypes.object,
  filterName: PropTypes.string,
  children: PropTypes.node,
  isCitation: PropTypes.bool,
}

ModalFilter.defaultProps = {
  filtersValues: {},
  filterName: '',
  children: <></>
}

const enharce = compose(withI18n)

export default enharce(ModalFilter)
